import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as R from 'ramda';
import styled from 'styled-components';

import { DisplayFlexS } from '../../../utils/stylesHelpers/DispalyFlexS';
import { getScreenSize, getThemeColor, getThemeFont, getThemeSize } from '../../../utils/theme';
import NoLogo from '../../assets/imgs/icons/NOlogo_Icon.svg';
import { Text } from '../common';

export const ContentWrapS = styled.div`
  margin: 30px auto 0;
  width: ${getScreenSize(['tabletPC'])};

  @media (max-width: ${getScreenSize(['tabletPC'])}) {
    width: 100%;
  }

  @media (max-width: ${getScreenSize(['medium'])}) {
    width: 100%;
    padding: 0;
    margin: 0 auto;
  }
`;

export const GoBackBtnWrapS = styled.div`
  margin-bottom: 25px;
  padding: 10px;
  border-bottom: 2px solid ${getThemeColor(['grayBlue'])};

  &:hover {
    cursor: pointer;
  }

  @media (max-width: ${getScreenSize(['medium'])}) {
    margin-bottom: 23px;
  }
`;

export const AdvertismentBlockS = styled.div`
  margin: 30px 0 40px;
  @media (max-width: ${getScreenSize(['medium'])}) {
    margin: 0 0 10px;
  }
`;

export const BaseBlockStyled = styled.div`
  margin-bottom: 20px;
  border-radius: 3px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);

  background-color: ${getThemeColor(['white'])};

  @media (max-width: ${getScreenSize(['medium'])}) {
    margin: 0;
    padding: 0;
  }
`;

export const ContactFormWrapperS = styled(BaseBlockStyled)`
  margin-bottom: 15px;
  padding: 0;

  @media (max-width: ${getScreenSize(['medium'])}) {
    margin: 0 24px;
    padding: 0;
  }
`;

export const CompanyInfoWrapper = styled.div`
  @media (max-width: ${getScreenSize(['medium'])}) {
    margin-bottom: 62px;
    padding: 0 24px;
  }
`;

export const BaseBlockHeaderS = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: ${getThemeColor(['greyBlueLight'])};
`;

export const ContactFormWrapperSHeaderS = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${getThemeColor(['greyBlueLight'])};
  padding: 28px 34px;
  
  @media (max-width: ${getScreenSize(['medium'])}) {
    margin: 0;
    padding: 16px;
  }
`;

export const BlockInformation = styled.div`
  margin-bottom: 20px;
`;

export const InfoBaseBlock = styled(BaseBlockStyled)`
  margin-bottom: 15px;

  & > div {
    margin-bottom: 0;
  }

  @media (max-width: ${getScreenSize(['medium'])}) {
    margin: 0 24px 60px;
    padding: 26px 12px 15px;
  }
`;

export const BaseInfoBlockFooterS = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 40px;
  margin: 0 -34px -20px -34px;
  padding-right: 20px;
  background-color: ${getThemeColor(['greyBlueLight'])};
  border-radius: 0 0 3px 3px;

  & span {
    color: ${getThemeColor(['darkBlue'])};
  }
  @media (max-width: ${getScreenSize(['medium'])}) {
    font-size: ${getThemeSize(['smallText'])};
    font-weight: 400;
    line-height: 13.2px;
    text-align: center;
    margin: 0;
    margin-top: 52px;
    & span {
      color: ${getThemeColor(['darkerViolet'])};
    }
  }
`;

export const CompanyLogoWrapS = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  flex: 0 0 20%;
  max-width: 20%;

  margin-right: 20px;

  @media (max-width: ${getScreenSize(['medium'])}) {
    margin-bottom: 20px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const CommunPreferencesWrapperS = styled.div`
  display: flex;
  font-size: ${getThemeSize(['bigText'])};
  line-height: 24px;
  color: ${getThemeColor(['darkerViolet'])};
  margin-bottom: 15px;

  svg {
    margin-top: 2px;
    margin-right: 4px;
    font-size: 18px;
    color: ${getThemeColor(['violet'])};
  }
`;

export const CompanyBorderImage = styled.div`
  margin: 5px auto 25px;

  width: 140px;
  height: 140px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 50%;
  border: 1px solid ${getThemeColor(['grayBlue'])};

  background: ${getThemeColor(['white'])} url(${({ logo }) => logo || NoLogo}) center no-repeat;
  background-size: ${({ logo }) => (logo ? 'contain' : '50%')};
`;

export const CompanyBaseInfoWrapS = styled.div`
  flex-basis: 80%;
  text-transform: lowercase;
  font-size: ${getThemeSize(['bigText'])};

  @media (max-width: ${getScreenSize(['medium'])}) {
    display: none;
  }
`;

export const HeaderRowS = styled.h1`
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;

  color: ${getThemeColor(['violet'])};
  font-size: ${getThemeSize(['headers', 'authModal'])};
  font-family: ${getThemeFont(['bold'])};
  text-transform: uppercase;
`;

export const ButtonEditWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const CompanyInfoRowS = styled(DisplayFlexS)`
  margin-bottom: 10px;
  align-content: flex-start;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: ${getScreenSize(['medium'])}) {
    flex-direction: column;

    & > div {
      margin-bottom: 10px;
    }
  }
`;

export const CompanyInfoItemS = styled(DisplayFlexS)`
  width: auto;
  margin-right: ${R.propOr('15px', 'marginRight')};
  color: ${getThemeColor(['black'])};
  line-height: 1.3;
  > span {
    margin-right: 10px;
  }
`;

export const CompanyInfoNameS = styled.h3`
  flex-basis: 20%;
  flex-shrink: 0;
  flex-grow: 0;
  margin-right: 20px;
  color: ${getThemeColor(['violet'])};
  font-size: ${getThemeSize(['bigText'])};
  font-family: ${getThemeFont(['bold'])};

  @media (max-width: ${getScreenSize(['medium'])}) {
    margin-bottom: 6px;
    font-size: ${getThemeSize(['mediumText'])};
    font-weight: 700;
    line-height: 15.6px;
    color: ${getThemeColor(['darkerViolet'])};
    font-family: ${getThemeFont(['regular'])};
    padding: 0 24px;
  }
`;

export const DataWrapS = styled.div`
  margin-bottom: 20px;
  word-break: break-word;
`;

export const TextCHF = styled(Text)`
  white-space: nowrap;
  color: ${getThemeColor(['black'])};
`;

export const Tag = styled(Text)`
  display: inline-block;
  position: relative;
  z-index: 1;

  &:before {
    content: ' ';
    display: inline-block;
    position: absolute;
    z-index: -1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: ${getThemeColor(['grayBlue'])};
    border-radius: 14px;
    height: 28px;
    width: 130%;
  }

  @media (max-width: ${getScreenSize(['medium'])}) {
    &:before {
      height: 18px;
    }
  }
`;

// Slider Photos

export const SliderPhotosListS = styled.div``;

export const SliderPhotosItemS = styled.div`
  margin: 0 5px;
`;
export const SliderPhotosPictureS = styled.img`
  width: 100%;
  height: 160px;
  object-fit: cover;
  cursor: pointer;

  @media (max-width: ${getScreenSize(['medium'])}) {
    height: 125px;
    min-width: 186px;
  }
`;
export const WHTimeRow = styled.div`
  margin-bottom: 8px;
  text-transform: none;
  font-size: ${getThemeSize(['bigText'])};
  color: ${getThemeColor(['darkerViolet'])};

  b {
    text-transform: uppercase;
    color: ${getThemeColor(['darkerViolet'])};
  }
`;

// Social Link

export const SocialLinkWrS = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 20px;
`;

export const SocialLinkS = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 22px;
  max-width: 22px;
  height: 22px;
  &:not(:last-of-type) {
    margin-right: 15px;
  }
`;

// Employee Team
export const EmployeeSectionNameS = styled.div`
  font-size: ${getThemeSize(['normalText'])};
  color: ${getThemeColor(['darkerViolet'])};
  margin-left: 50px;
  margin-bottom: 15px;

  @media (max-width: ${getScreenSize(['medium'])}) {
    margin: 0 0 8px 24px;
    font-family: ${getThemeFont(['regular'])};
    font-size: ${getThemeSize(['mediumText'])};
    font-weight: 700;
    line-height: 13.2px;
    text-align: left;
    color: ${getThemeColor(['darkerViolet'])};
  }
`;

export const EmployeeWrS = styled.div`
  font-size: ${getThemeSize(['normalText'])};
  outline: none;
  padding-bottom: 5px;
  margin: 0 -10px;
`;

export const EmployeeItemS = styled.div`
  margin: 0 10px;

  @media (max-width: ${getScreenSize(['medium'])}) {
    margin: 0;
  }
`;

export const EmployeeAvatarS = styled.div`
  height: 190px;
  background-color: ${getThemeColor(['grayBlue'])};
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin-bottom: 10px;
  ${({ isAvatar }) =>
    isAvatar &&
    `
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `}
  @media (max-width: ${getScreenSize(['medium'])}) {
    ${({ isAvatar }) =>
      isAvatar &&
      `
      img {
        height: 186px;
      }
    `}
  }
`;

export const EmployeeNameS = styled.div`
  color: ${getThemeColor(['black'])};
  margin-bottom: 10px;
  @media (max-width: ${getScreenSize(['medium'])}) {
    margin-bottom: 5px;
    font-size: ${getThemeSize(['smallText'])};
  }
`;
export const EmployeeJobS = styled.div`
  color: ${getThemeColor(['primaryGray'])};
  margin-bottom: 10px;
  @media (max-width: ${getScreenSize(['medium'])}) {
    margin-bottom: 5px;
    font-size: ${getThemeSize(['smallText'])};
  }
`;

export const EmployeeEducationS = styled.div`
  color: ${getThemeColor(['primaryGray'])};
  margin-bottom: 10px;
  @media (max-width: ${getScreenSize(['medium'])}) {
    margin-bottom: 5px;
    font-size: ${getThemeSize(['smallText'])};
  }
`;

export const EmployeeEmailS = styled.a`
  color: ${getThemeColor(['darkerViolet'])};
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
  @media (max-width: ${getScreenSize(['medium'])}) {
    white-space: nowrap;
    font-size: ${getThemeSize(['smallText'])};
  }
`;

export const EmployeeEmailIconS = styled(FontAwesomeIcon)`
  margin-right: 5px;
`;

export const CompanyTitleS = styled.p`
  font-size: 18px;
  font-family: ${getThemeFont(['bold'])};

  @media (max-width: ${getScreenSize(['medium'])}) {
    font-family: ${getThemeFont(['regular'])};
    font-size: ${getThemeSize(['smallText'])};
    font-weight: 700;
    line-height: 15.6px;
    text-align: right;
    color: ${getThemeColor(['darkerViolet'])};
  }
`;

export const CompanyNavWrapS = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  margin: 30px 0;
  border-bottom: 2px solid ${getThemeColor(['grayBlue'])};

  @media (max-width: ${getScreenSize(['medium'])}) {
    margin: 10px 0 23px;
    padding: 0 24px 7px;
  }
`;

export const GoBackBtnCompanyS = styled.div`
  cursor: pointer;

  & span {
    font-size: 18px;
  }
  & span.chevron {
    margin-right: 15px;
  }
  @media (max-width: ${getScreenSize(['medium'])}) {
    & span.chevron {
      width: 12px;
      height: 17px;
      margin-right: 7px;
      color: ${getThemeColor(['red'])};
      top: 2px;
      position: relative;
    }
    & span {
      font-family: ${getThemeFont(['regular'])};
      font-size: ${getThemeSize(['smallText'])};
      font-weight: 700;
      line-height: 15.6px;
      text-align: left;
      color: ${getThemeColor(['darkerViolet'])};
    }
  }
`;

export const EditButtonS = styled.div`
  display: none;
  @media (max-width: ${getScreenSize(['medium'])}) {
    margin: 35px auto 18px;
    display: flex;
    justify-content: center;
  }
`;

// Tax representation
export const CheckIconS = styled(FontAwesomeIcon)`
  font-size: ${getThemeSize(['largeText'])};
  color: ${getThemeColor(['green'])};
`;

export const TimesIconS = styled(FontAwesomeIcon)`
  font-size: ${getThemeSize(['largeText'])};
  color: ${getThemeColor(['red'])};
`;

export const CompanyCardWrapper = styled.div`
  padding: 0 24px;
`;

export const PicturesSliderWrapperS = styled.div`
  width: 78%;

  @media (max-width: ${getScreenSize(['medium'])}) {
    width: 100%;
    margin-top: 13px;
    margin-bottom: 32px;

    & .slick-track {
      display: flex;
    }
    & .slick-current {
      width: 186px !important;
      margin-right: 23px;
      margin-left: -5px;
      flex-grow: 1;
      & img {
        min-width: 186px;
      }
    }
    & .slick-arrow {
      display: none;
    }
  }
`;
export const CompanyMobileHeaderS = styled.div`
  display: flex;
  background: ${getThemeColor(['grayBlue'])};
  padding: 25px 5px;
  flex-direction: row;
  align-items: center;
`;

export const CompanyLogoS = styled.img`
  width: 63px;
  height: 63px;
  border-radius: 50%;
  margin-right: 12px;
`;

export const CompanyNameS = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;

  & h4 {
    font-size: ${getThemeSize(['mediumText'])};
    font-weight: 700;
    line-height: 15.6px;
    text-align: center;
    color: ${getThemeColor(['violet'])};
  }
`;

export const VerifiedIconS = styled.img`
  margin-left: 3px;
  width: 17px;
  height: 17px;
`;

export const RatingSectionS = styled.div`
  .rating-container {
    display: flex;
    flex-direction: column-reverse;

    & > div {
      align-items: center;
      margin: 0 !important;
      display: flex;
      flex-direction: row;

      & img {
        width: 15px;
        height: 15px;
        margin-right: 6px;
      }

      & span {
        margin: 0 3px 0 0;
        font-size: ${getThemeSize(['smallText'])};
        font-weight: 400;
        line-height: 24px;
        text-align: center;
      }

      & svg {
        width: 13px;
        height: 13px;
      }
    }
  }
`;

export const ContactInfoS = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 16px 27px 24px;
`;

export const ContactItemS = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

export const ScheduleItemS = styled.div`
  display: flex;
`;

export const ContactIconS = styled.img`
  margin-right: 13px;
  width: 20px;
  height: 20px;
`;

export const ContactTextS = styled.span`
  font-size: ${getThemeSize(['mediumText'])};
  font-weight: 400;
  line-height: 15.6px;
  text-align: left;
  color: ${getThemeColor(['darkerViolet'])};
`;

export const ContactIconsWrapper = styled.div`
  padding: 19px 0 0;
  display: flex;
`;

export const ContactRowIconS = styled.img`
  width: 20px;
  height: 20px;
  display: inline-block;
  margin-right: 15px;

  &:last-of-type {
    margin-right: 0;
  }
`;

export const EmployeesBlockWrapper = styled.div`
  @media (max-width: ${getScreenSize(['medium'])}) {
    & > ${BlockInformation} {
      width: 100%;
    }

    & > ${CompanyInfoNameS} {
    }
  }
`;

export const TeamSlidersWrapper = styled.div`
  width: 78%;
  @media (max-width: ${getScreenSize(['medium'])}) {
    width: 100%;
    & .slick-slide {
      width: 157px !important;
      margin-left: 10px;
      margin-right: 60px;
    }
    & .slick-track {
      display: flex;
      flex-wrap: nowrap;
    }

    & .slick-arrow {
      display: none;
    }
    & .slick-current:not([data-index='0']) {
      margin-left: 40px;
    }
  }
`;
